
import { debugMode, USE_FUSE_ONLY } from './filter-logic-config.js';

function getFuseIconTooltip() {
    const lang = (window.LANG || window.LANG_FROM_SERVER || 'EN').toUpperCase();

    if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        const translation = window.TranslationRegistry.translate('fuse_icon_tooltip', lang);
        if (translation !== 'fuse_icon_tooltip') {
            return translation;
        }
    }

    // Fallback translations (should be added to static/js/translations/pages/search/translations.json)
    const fallbackTranslations = {
        'RU': 'Включен нечеткий поиск (Fuse.js). Обычный поиск не нашел точных совпадений по имени или пути файла, поэтому результаты отсортированы с помощью нечеткого поиска',
        'EN': 'Fuzzy search enabled (Fuse.js). Regular search found no exact matches by file name or path, so results are sorted using fuzzy search',
        'DE': 'Fuzzy-Suche aktiviert (Fuse.js). Die normale Suche hat keine exakten Übereinstimmungen nach Dateiname oder Pfad gefunden, daher werden die Ergebnisse mit Fuzzy-Suche sortiert'
    };
    return fallbackTranslations[lang] || fallbackTranslations['EN'];
}

/**
 * Update Fuse.js icon visibility on the names-card navigation tab.
 * Currently force-hidden by user request (showIcon = false unconditionally).
 */
export function updateFuseIcon(showIcon = false) {
    // Иконка fuse.png отключена по запросу пользователя
    showIcon = false;

    const navButton = document.getElementById('nav-names-card-tab');
    if (!navButton) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => updateFuseIcon(showIcon));
        }
        return;
    }

    let fuseIcon = navButton.querySelector('.fuse-icon-overlay');

    if (showIcon && USE_FUSE_ONLY) {
        if (!fuseIcon) {
            fuseIcon = document.createElement('img');
            fuseIcon.src = '/static/assets/images/brands/fuse.png';
            fuseIcon.className = 'fuse-icon-overlay position-absolute';
            fuseIcon.alt = 'Fuse.js';
            fuseIcon.setAttribute('data-bs-toggle', 'tooltip');
            fuseIcon.setAttribute('data-bs-placement', 'top');
            fuseIcon.setAttribute('data-bs-trigger', 'hover focus');
            navButton.appendChild(fuseIcon);
        }
        const tooltipText = getFuseIconTooltip();
        fuseIcon.title = tooltipText;
        fuseIcon.setAttribute('data-bs-title', tooltipText);

        if (window.bootstrap && typeof window.bootstrap.Tooltip === 'function') {
            const existingTooltip = window.bootstrap.Tooltip.getInstance(fuseIcon);
            if (existingTooltip) existingTooltip.dispose();
            try {
                new window.bootstrap.Tooltip(fuseIcon, {
                    trigger: 'hover focus',
                    placement: 'top',
                    html: false
                });
            } catch (e) {
                if (debugMode === '1') {
                    console.warn('[FilterManager] Failed to initialize Fuse icon tooltip:', e);
                }
            }
        }
        fuseIcon.classList.remove('hidden');
        return;
    }

    if (fuseIcon) {
        if (window.bootstrap && typeof window.bootstrap.Tooltip === 'function') {
            const existingTooltip = window.bootstrap.Tooltip.getInstance(fuseIcon);
            if (existingTooltip) existingTooltip.dispose();
        }
        fuseIcon.classList.add('hidden');
    }
}

// Initialize hidden on page load (preserves original module-level side effect)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateFuseIcon(false));
} else {
    updateFuseIcon(false);
}
